/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Homepage { 
    archived?: boolean;
    bannerText?: string;
    bottomRightHeader?: string;
    bottomRightImage?: string;
    bottomRightLink?: string;
    bottomRightLinkText?: string;
    bottomRightYoutubeLink?: string;
    buglePdf?: string;
    createdAt?: string;
    heroImage?: string;
    heroLink?: string;
    heroLinkText?: string;
    heroText?: string;
    heroYoutubeLink?: string;
    historyHeroHeader?: string;
    historyHeroImage?: string;
    historyHeroLink?: string;
    historyHeroLinkText?: string;
    historyHeroText?: string;
    historyHeroTopText?: string;
    historyHeroVideoUrl?: string;
    id?: string;
    importObjectKey?: string;
    importSessionKey?: string;
    locked?: boolean;
    published?: boolean;
    readOnly?: boolean;
    topRightHeader?: string;
    topRightImage?: string;
    topRightLink?: string;
    topRightLinkText?: string;
    topRightYoutubeLink?: string;
    updatedAt?: string;
    version?: number;
}
